import axios from 'api/axios';
import { ReturnType } from 'utils/helpers';
import { SourceChannelType, TouchType } from 'utils/types';

export type TouchesPayload = {
  source: ReturnType | null;
  vacancyId: number;
  date: Date;
  touchesNumber: string | number;
  touchesComment: string;
  positiveNumber: string | number;
  positiveComment: string;
  negativeNumber: string | string;
  negativeComment: string;
}

export type TouchesStatisticType = {
  raw: number;
  rate: string;
  groupedBySource: {
    [key: string]: {
      raw: number;
      source: SourceChannelType;
    }
  }
}

export type VacancyStatisticType = {
  positiveResponses: TouchesStatisticType;
  sentForReview: TouchesStatisticType;
  interview: TouchesStatisticType;
  rejected: TouchesStatisticType;
  offer: TouchesStatisticType;
}

const path = '/touch';

export const create = (data: TouchesPayload): Promise<TouchType> => axios.post(`${path}`, data);

export const update = (touchId: number, data: Partial<TouchesPayload>): Promise<TouchType> => axios.patch(`${path}/${touchId}`, data);

export const getVacancyStatistic = (vacancyId: number): Promise<VacancyStatisticType> => axios.get(`${path}/vacancy-statistic/${vacancyId}`);

export const getList = (userId?: number) => axios.get(path, {
  params: {
    userId,
  },
});

const touchApi = {
  create,
  getList,
  update,
  getVacancyStatistic,
};

export default touchApi;
